import React from "react";
import ServicePageShell from "../ui/ServicePageShell";
import { PrimaryLink } from "../ui/Buttons";
import CallButton from "../ui/CallButton";
import DirectionsButton from "../ui/DirectionsButton";
import BusinessHours from "../ui/BusinessHours";
import ReviewSection from "../ui/ReviewSection";
import SeoHead from "../seo/SeoHead";
import PageBreadcrumb from "../seo/PageBreadcrumb";
import SUS from "../../assets/Suspension.png";

const BrakesAndSuspension = () => {
  return (
    <>
      <SeoHead
        title="Brake & Suspension Repair in Temecula | Advanced Automotive Smog"
        description="Brake and suspension service in Temecula, including pads, rotors, struts, and shocks, to help keep your ride safe, stable, and comfortable."
        path="/services/brake-suspension"
      />
      <ServicePageShell>
        <PageBreadcrumb
          label="Brakes and Suspension Services"
          path="/services/brake-suspension"
          description="Brake and suspension service in Temecula, including pads, rotors, struts, and shocks."
          serviceType="Brake and suspension repair"
        />
        
        <div className="flex flex-col gap-10 md:flex-row md:items-center md:gap-14">
          
          {/* Image - prioritized for mobile */}
          <div className="w-full md:w-1/2 flex justify-center order-1 md:order-none">
            <div className="relative w-full max-w-xs sm:max-w-sm">
              <div className="absolute -inset-3 rounded-3xl bg-teal-600/10 blur-xl" />
              <img
                src={SUS}
                alt="Brakes and suspension service"
                className="relative w-full h-auto rounded-3xl border border-slate-200 object-cover shadow-xl"
              />
            </div>
          </div>

          {/* Text content */}
          <div className="w-full md:w-1/2">
            <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-[11px] font-medium tracking-normal text-teal-700">
              <span className="h-1.5 w-1.5 rounded-full bg-teal-600" />
              Brake & Suspension Service
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-navy-900 mb-3">
              Brakes and Suspension Services
            </h1>

            <p className="text-sm sm:text-base text-slate-700 mb-6 leading-relaxed">
              Your brake and suspension systems work together to keep your ride
              safe, stable, and smooth. We provide reliable repairs and
              maintenance to restore control and comfort on every road.
            </p>

            <h2 className="text-lg sm:text-xl font-semibold text-teal-600 mb-2">
              What Are Brakes and Suspension Services?
            </h2>

            <p className="text-sm sm:text-base text-slate-700 mb-5 leading-relaxed">
              Over time, brake pads, rotors, struts, shocks, and suspension
              components can wear out—affecting stopping power, steering
              stability, and ride comfort.
              <br />
              <br />
              Our service includes inspection, diagnosis, replacement, and
              adjustment of brake and suspension components to ensure your
              vehicle handles safely and predictably.
            </p>

            <ul className="space-y-2.5 text-sm sm:text-base text-slate-700">
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Reliable brake and suspension repairs</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>High-quality parts for long-lasting performance</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Professional inspections and adjustments</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Safe for all makes and models</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Improves handling, braking, and ride comfort</span>
              </li>
            </ul>

            {/* Clean centered button */}
            <div className="mt-8 flex justify-center">
              <PrimaryLink
                to="/contact"
                className="px-10 text-base"
              >
                Book Appointment
              </PrimaryLink>
            </div>

          </div>

        </div>

        <div className="mt-14 space-y-10 border-t border-slate-200 pt-12">
          <BusinessHours tone="light" />
          <ReviewSection tone="light" />
          <div className="flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:justify-center">
            <CallButton className="px-8 py-3 text-base" />
            <DirectionsButton className="px-8 py-3 text-base" />
          </div>
        </div>
    </ServicePageShell>
    </>
  );
};

export default BrakesAndSuspension;








